import { render } from "./ClaimExpenses.vue?vue&type=template&id=6a9dd8d1&scoped=true"
import script from "./ClaimExpenses.vue?vue&type=script&lang=js"
export * from "./ClaimExpenses.vue?vue&type=script&lang=js"

import "./ClaimExpenses.vue?vue&type=style&index=0&id=6a9dd8d1&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9dd8d1"]])

export default __exports__